import { LISTING_STATE_CLOSED } from './types';

export const SOFT_DELETE_REASON = 'user_deleted';

export const isSoftDeletedListing = listing => {
  const { state, privateData = {} } = listing?.attributes || {};
  return (
    state === LISTING_STATE_CLOSED &&
    (privateData.closedByUser === true || privateData.closedReason === SOFT_DELETE_REASON)
  );
};

export const createSoftDeletePrivateData = () => ({
  closedByUser: true,
  closedReason: SOFT_DELETE_REASON,
  closedAt: new Date().toISOString(),
});

export const createRestorePrivateData = () => ({
  closedByUser: false,
  closedReason: '',
  closedAt: '',
  reopenedAt: new Date().toISOString(),
});
